import { useQuery } from "@tanstack/react-query";
import Title from "../components/ui/Title";
import { ksDernierAbonnementQK } from "../lib/query-keys";
import { findDernierAbonnement } from "../lib/queries/abonnement-queries";
import { Skeleton } from "../components/ui/skeleton";
import Box from "../components/ui/Box";
import BlocAbonnement from "../components/abonnement/BlocAbonnement";
import logoAdf from "../assets/img/logo-adf.png";
import logoSna from "../assets/img/logo-sna-transparent.png";
import Divider from "../components/ui/Divider";
import BlocHistoriqueAbonnements from "../components/abonnement/BlocHistoriqueAbonnements";
import BlocHistoriqueAssurances from "../components/assurances/BlocHistoriqueAssurances";
import BlocFacturesAPayers from "../components/factures/BlocFacturesAPayers";

const AbonnementPage = () => {
  const { data: abo, isError } = useQuery({
    queryKey: [ksDernierAbonnementQK],
    queryFn: findDernierAbonnement,
  });

  return (
    <>
      <Title className="mb-6">Mon abonnement</Title>
      <BlocFacturesAPayers />
      <Box className="w-full">
        <div className="flex flex-row gap-5">
          <div className="h-10 md:h-14">
            <img
              className="h-full"
              src={logoAdf}
              alt="Logo de l'Abeille de France"
            />
          </div>
          {!!abo && abo.type === "A" && (
            <div className="h-10 md:h-14">
              <img
                className="h-full"
                src={logoSna}
                alt="Logo de l'Abeille de France"
              />
            </div>
          )}
        </div>
        <Divider className="mt-3" />
        {/* LOADING */}
        {abo === undefined && <Skeleton className="w-full h-24 mt-4" />}

        {/* ERROR */}
        {isError && (
          <div className="text-red-500">
            Une erreur s'est produite à la récupération de votre abonnement.
          </div>
        )}

        {/* DATA */}
        {abo !== undefined && <BlocAbonnement abonnement={abo} />}
      </Box>

      <div className="flex flex-col md:flex-row gap-3 md:gap-6 mt-7">
        <div className="flex-1">
          <BlocHistoriqueAbonnements />
        </div>
        <div className="flex-1">
          <BlocHistoriqueAssurances />
        </div>
      </div>
      {/*  */}
    </>
  );
};

export default AbonnementPage;
